import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description: `Play with the physical parameters of the loudspeaker to see their effect on the impedance and frequency response curves. Note that the "datasheet parameters" in the drop-down menu are defined in the next lesson, so please read it and return to this page.`,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0418/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
